import { isProd } from '~/utils';

const customLogger = new Proxy(console, {
  get: (target, property) => {
    if (['log', 'error', 'warn', 'info', 'debug', 'assert', 'clear', 'trace'].includes(property)) {
      return (...args) => {
        if (!isProd()) {
          target[property](...args);
        }
      };
    } else {
      return target[property];
    }
  },
});

export default customLogger;
